import { useState } from 'react'


export default function ForgotPassword() {
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState(null)
    const [loading, setLoading] = useState(false)


    async function handleSubmit(e) {
        e.preventDefault()
        setLoading(true)
        setMessage(null)
        try {
            const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            })
            const data = await res.json()
            if (!res.ok) throw new Error(data.message || 'Failed')
            setMessage(data.msg || 'If an account exists, an email has been sent with reset instructions.')
        } catch (err) {
            setMessage(err.message)
        } finally {
            setLoading(false)
        }
    }


    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow">
                <h1 className="text-2xl font-semibold mb-4">Reset your password</h1>
                <p className="text-sm text-gray-600 mb-6">Enter the email associated with your account and we'll send a link to reset your password.</p>
                {message && <div className="mb-4 text-sm text-green-700 bg-green-50 p-3 rounded">{message}</div>}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="w-full p-2 rounded-md border-gray-200" />
                    <button type="submit" disabled={loading} className="w-full py-2 rounded-lg bg-indigo-600 text-white">{loading ? 'Sending...' : 'Send reset link'}</button>
                </form>
            </div>
        </div>
    )
}